export const EditBookmark = {
  "Modal": {
    "Title": "Edit BookMark for File"
  },
  "Label": {
    "Bookmark4File": "Bookmark for File"
  },
  "Button": {
    "OK": "OK",
    "Cancel": "Cancel"
  }
}